export const NO_ID = -1;
export const MY_USER_ID = '__hs__ID';
export const MY_OWNER_ID = '__hs__ME';
export const MY_TEAM_ID = '__hs__MY_TEAM';
export const CLOSEDWON_STAGES = '__hs__CLOSEDWON';
export const CURRENT_TIME = '__current_time__';
export const SELECT_TOP = '__select__top__';